import { render, staticRenderFns } from "./v-text-field.vue?vue&type=template&id=bf4ed3b0&scoped=true&"
import script from "./v-text-field.vue?vue&type=script&lang=js&"
export * from "./v-text-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4ed3b0",
  null
  
)

export default component.exports